import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import { getDarkenColor } from '../../../utils/helper';

const StyledInput = styled(Form.Control)`
  padding: 10px 18px;
  width: 100%;
  border-radius: 6px;
  border: ${({ $borderWidth }) => $borderWidth ?? '1.5px'} solid
    ${({ theme, newinput }) =>
      newinput === 'true' ? theme.dark70 : theme.sectionBorder};
  display: flex;
  align-items: center;
  color: ${({ theme, newinput }) =>
    newinput ? theme.dark40 : theme.headingColor} !important;
  font-size: ${({ theme, newinput }) =>
    theme.$phFontSize || theme.$fontSize || newinput === 'true'
      ? '18px'
      : '14px'};
  font-weight: ${({ $fontWeight }) => $fontWeight ?? '400'};
  font-family: ${({ theme, newinput }) =>
    newinput === 'true' ? theme.fontFamily : ''};

  &:focus {
    box-shadow: none;
    color: ${({ theme, newinput }) =>
      newinput === 'true' ? theme.dark40 : theme.headingColor} !important;
    border: 1.5px solid
      ${({ theme, newinput }) =>
        newinput === 'true' ? theme.dark40 : getDarkenColor('primary', theme)};
  }
  &:focus-within {
    color: ${({ theme, newinput }) =>
      newinput === 'true' ? theme.dark40 : theme.headingColor} !important;
    border: 1.5px solid
      ${({ theme, newinput }) =>
        newinput === 'true' ? theme.dark40 : getDarkenColor('primary', theme)};
    background-color: ${({ theme }) => theme.white};
  }
  //add styles when input has value
  //&:not(:placeholder-shown)
  &:valid {
    background-image: none;
  }

  &::placeholder {
    font-weight: 400;
    font-size: ${({ theme }) => theme.$phFontSize || theme.$fontSize || '18px'};
    color: ${({ $phcolor, theme, newinput }) =>
      newinput === 'true'
        ? theme.bodyLight
        : $phcolor
        ? theme[$phcolor]
        : theme.placeholderColor};
    opacity: 1;
  }

  &[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='range'] {
    height: 2px;
    border: none;
    outline: none;
    padding: 15px 0;

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 3px;
      cursor: pointer;
      animate: 0.2s;
      background: ${({ theme }) => theme.primary};
      border-radius: 3px;
    }

    &::-webkit-slider-thumb {
      border: 1px solid ${({ theme }) => theme.inputBorder};
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background: ${({ theme }) => theme.white};
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -9px;
    }
  }
`;

export default StyledInput;
